/* global grecaptcha */
import {Backbone, $, _} from "backboneAdapter";
import i18n from "l10n";
import XRegExp from "xregexp";
import moment from "moment";
import BaseOuterView from "views/base.outer.view.js";
import dhtmlx from "dhtmlxAdapter";
import Optional from "optional-js";
import RegistrationTemplate from 'templates/registration.hbs';
import Handlebars from "handlebars";
import sha1 from 'sha1';
import 'passwordStrength';
import 'moment-timezone';
import 'parallax';
import 'metroHelpers';
import 'zxcvbn';

const constraints = {
    disabledThirdPartyActions: false,
    usernameCompleted: false,
    passwordCompleted: false,
    emailCompleted: false
};

const RegistrationView = BaseOuterView.extend({
    template: Handlebars.compile(RegistrationTemplate),
    el: '#page-main-content',
    initialize: function (options) {
        var self = this;
        this.rx = XRegExp('\\p{L}'); //Require.js does not pass this on older browsers
        this.bootstrap(options).finally(() => {
            this.render();

            const passwordLevelLabel = "";

            $('#password').pwstrength({
                i18n: i18n,
                ui: {
                    verdicts: [
                        i18n.t("veryWeak", {label: passwordLevelLabel}),
                        i18n.t("weak", {label: passwordLevelLabel}),
                        i18n.t("normal", {label: passwordLevelLabel}),
                        i18n.t("medium", {label: passwordLevelLabel}),
                        i18n.t("strong", {label: passwordLevelLabel}),
                        i18n.t("veryStrong", {label: passwordLevelLabel})
                    ],
                    colorClasses: ["danger", "danger", "danger", "warning", "success", "success"]
                },
                common: {
                    zxcvbn: true,
                    onKeyUp: function (evt, data) {
                        var strongPass = data.verdictLevel > 3;
                        if (data.verdictLevel > 0) _.bind(self.checkPassword, self)(strongPass);
                    }
                }
            });

            console.info('Initializing Registration View');
            var browser = $.get_browser();
            if (!(browser.name === "Firefox" || browser.name === "Chrome")) {
                dhtmlx.alert(i18n.t("voucher.betterbrowserview"));
            }
            var isPostpaid = this.isPostpaid;
            if (isPostpaid) {
                $(".tellyBottom").remove();
                $(".alternative-registration").remove();
                $(".tellody-logo").remove();
                $("#terms-and-conditions-container").find("a").first().attr("href", "/terms_and_conditions.pdf");
            }
            $('#showHidePassword').click(function (e) {
                var $psw = $('#password');
                var $this = $(e.currentTarget);
                var $label = $this.find('span').first();
                var $icon = $this.find('icon').first();
                var hidden = $psw.attr('type') === 'password';
                if (hidden) {
                    $psw.attr('type', 'text');
                    $label.text(i18n.t('hide'));
                    $icon.removeClass().addClass('fak fa-eye-slash');
                } else {
                    $psw.attr('type', 'password');
                    $label.text(i18n.t('show'));
                    $icon.removeClass().addClass('fak fa-eye');
                }
            });
            $('#email').on('blur', function () {
                if (constraints.emailCompleted) {
                    self.haveibeenpwned($('#email').val());
                } else {
                    console.log('Blur but !constraints.emailCompleted');
                }
            });
            $('#password').on('blur', function() {
                self.haveibeenpwned_pwd($('#password').val());
            });
        });
    },

    events: {
        "click [data-navigation]": "notifyNavigator",
        "click #submit-btn": "submitRegistration",
        "input #username": "checkUserName",
        "input #email": "checkEmail",
        "click #google": "googleAuth",
        "click #yahoo": "yahooAuth",
        "click #microsoft": "microsoftAuth",
        "click #facebook": "facebookAuth",
        "propertychange #email": "checkEmail"
    },

    render() {
        this.$el.html(this.template({fbApi:!!this.fbApi}));
        grecaptcha.render($(".g-recaptcha").get(0));
        setTimeout(() => {
            if($('#username').is(':-webkit-autofill')) {
                this.checkUserName();
            }
            if($('#email').is(':-webkit-autofill')) {
                this.checkEmail();
            }
            if($('#password').is(':-webkit-autofill')) {
                this.checkPassword();
            }

        },3000);
    },
    haveibeenpwned_pwd: async function(pwd) {
        const $haveibeenpwned = $('#haveibeenpwned-pwd-error-message');
        let s = sha1(pwd).toUpperCase();
        let prefix = s.substring(0,5);
        let suffix = s.substring(5);
        const breachesopt = await $.ajaxDefaultQ({
            url: 'https://api.pwnedpasswords.com/range/' + prefix,
            type: 'GET',
            dataType: "text"
        });
        if(breachesopt.length) {
            let lines = breachesopt.split('\n');
            let found = lines.filter(e => e.startsWith(suffix));
            if(found.length) {
                let cnt = parseInt(found[0].split(':')[1]);
                console.log('Found:' + cnt);
                $haveibeenpwned
                    .show()
                    .html(i18n.t('register.haveibeenpwned-pwd-warning', {count: cnt}));
            } else {
                $haveibeenpwned.hide().html('');
            }
        } else {
            $haveibeenpwned.hide().html('');
        }
    },
    haveibeenpwned: async function (email) {
        const $haveibeenpwned = $('#haveibeenpwned-error-message');
        if ($('#email').is(':focus')) {
            console.log('EmailCompleted but focus');
            $haveibeenpwned.hide().text();
        } else {
            const breachesopt = await $.ajaxDefaultQ({
                url: '/CampaignCloud/UserInfo/haveibeenpwned',
                type: 'POST',
                data: {email: email},
                dataType: "json"
            });
            if (breachesopt.length) {
                $haveibeenpwned
                    .show()
                    .html(i18n.t('register.haveibeenpwned-warning', {count: breachesopt.length}));
                _.forEach(breachesopt, function (e, i) {
                    $('#haveibeenpwned-error-message').find('#hibp-data')
                        .append($('<div/>').html(`#${i + 1}: ${e.description}`));
                });
            } else {
                $haveibeenpwned.hide().text();
            }
        }
    },

    keypress: function (e) {
        var which = e.which;
        var key = e.key;

        var isAlpha = this.rx.test(key);
        if (!isAlpha) {
            return;
        }
        var isUp = key.toUpperCase() === key; // uppercase
        var isLow = key.toLowerCase() === key; // lowercase
        // event.shiftKey does not seem to be normalized by jQuery(?) for IE8-
        var isShift = e.shiftKey ? e.shiftKey : (which === 16); // shift is pressed

        // uppercase w/out shift or lowercase with shift == caps lock
        if ((isUp && !isShift) || (isLow && isShift)) {
            $('#capsonalert').show();
        } else {
            $('#capsonalert').hide();
        }
    },
    checkUserName: function () {
        var $username = $('#username');
        var username = $username.val();
        var re = new RegExp(/^([A-Za-z0-9.]{6,30})$/);
        if (re.test(username)) {
            _.debounce(this.checkFieldValueExistence.bind(this, "username", username), 1000)();
        } else if (!username.length) {
            this.invalidateField("username");
        } else if (username.length < 6 || username.length > 30) {
            const msg = i18n.t("register.numberofcharacters");
            this.invalidateField("username", msg);
        } else {
            const msg = i18n.t("register.allowedcharacters");
            this.invalidateField("username", msg);
        }
        this.checkIfAllEmpty();
    },
    checkPassword: function (strongPass) {
        var $psw = $('#password');
        var pass = $psw.val();

        if (!pass.length) {
            this.invalidateField("password");
        } else if (!strongPass) {
            this.invalidateField("password");
            this.passwordProposal(pass, $("#username").val());
        } else {
            this.validateField("password");
        }
        this.checkIfAllEmpty();
    },
    validateField: function (fieldName) {

        var $field = $(`#${fieldName}`);
        $(`#${fieldName}-error-message`).parent().hide();
        $field.removeClass('confirm-failure-input-borders');
        $field.removeClass('invalid-input');
        $field.addClass('valid-input');
        constraints[`${fieldName}Completed`] = true;
        if (constraints.usernameCompleted && constraints.passwordCompleted && constraints.emailCompleted) {
            $('#submit-btn').removeAttr('disabled');
            $('#btn-warning').hide();
        }
    },
    invalidateField: function (fieldName, msg) {
        $(`#${fieldName}-error-message`).parent().show();
        var $field = $(`#${fieldName}`);
        if (msg) {
            $(`#${fieldName}-error-message`).show().html(msg);
            $field.removeClass('required-input');
            $field.addClass('confirm-failure-input-borders');
            $field.addClass('invalid-input');
        } else {
            $(`#${fieldName}-error-message`).hide();
            $field.addClass('required-input');
            $field.removeClass('confirm-failure-input-borders');
            $field.removeClass('invalid-input');
        }
        $field.removeClass('valid-input');
        constraints[`${fieldName}Completed`] = false;
        $('#submit-btn').attr('disabled', true);
        $('#btn-warning').show();
    },
    checkEmail: _.debounce(function () {
        if (this.isRemoved) return;
        var $email = $('#email');
        var email = $email.val();
        var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
        if (!re.test(email) || email.length === 0) {
            $('#haveibeenpwned-error-message').hide();
            constraints.emailCompleted = false;
            if (email.length === 0) {
                this.invalidateField("email");
            } else {
                this.invalidateField("email");
            }
        }
        else {
            $('#haveibeenpwned-error-message').hide();
            _.debounce(this.checkFieldValueExistence.bind(this, "email", email), 1000)();
        }
        this.checkIfAllEmpty();
    }, 500),
    async checkFieldValueExistence(fieldName, fieldValue) {
        if (this.isRemoved) return;
        try {
            const exist = await $.getDefaultJSONQ(`/CampaignCloud/UserInfo/existence/${fieldName}`, {
                value: fieldValue
            });
            if (exist) {
                switch(exist) {
                    case 1: this.invalidateField(fieldName, i18n.t(`register.${fieldName}exists`)); break;
                    case 2: this.invalidateField(fieldName, i18n.t(`register.${fieldName}existslocked`)); break;
                    case 3: this.invalidateField(fieldName, i18n.t(`register.invalid${fieldName}`)); break;
                }
            } else {
                this.validateField(fieldName);
            }
        } catch (e) {
            console.error(e);
            this.invalidateField(fieldName);
        }
    },
    passwordProposal: function () {
        var uname = $("#username").val();
        var pwd = $("#password").val();

        var pwdError = "";
        if (uname && uname.length && pwd.indexOf(uname) > -1) {
            pwdError += `<br/> - ${i18n.t("register.passwordnotusername")}`;
        }
        if (pwd.length <= 5) {
            pwdError += `<br/> - ${i18n.t("register.passwordlength")}`;
        }
        $('#password-error-message').html(pwdError);
    },
    async submitRegistration() {
        this.requestLoading = true;
        var isPostpaid = this.isPostpaid;
        var self = this;
        var url = '/CampaignCloud/Registration';
        var $username = $('#username');
        var $psw = $('#password');
        var $email = $('#email');
        var formValues = {
            username: $username.val(),
            password: $psw.val(),
            email: $email.val()
        };
        if (!isPostpaid) {
            var recaptchaResp = grecaptcha.getResponse();
            if (!recaptchaResp) {
                dhtmlx.alert(i18n.t("register.recaptchaempty"));
                return;
            }
            formValues['g-recaptcha-response'] = recaptchaResp;
        }
        if (isPostpaid && !$username.val().match("^30")) {
            dhtmlx.alert(i18n.t("register.missingUsernamePrefix"));
            return;
        }

        //validate registration form before submitting the data, to avoid inclusions of special characters in its fields
        if (!this.shouldSubmit()) {
            return;
        }

        const $registrationMessageContainer = $('#registration_message_container');
        $("#spinner").show();
        $('#submit-btn').attr('disabled', true);
        $('#btn-warning').hide();
        $email.attr('disabled', true);
        $username.attr('disabled', true);
        $psw.attr('disabled', true);
        $registrationMessageContainer.show();
        $('#registration-message').text(i18n.t("waiting_message"));
        try {
            const registrationResponse = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-TZ-Offset', -(new Date()).getTimezoneOffset());
                    xhr.setRequestHeader('X-TZ-Name', moment.tz.guess());
                },
                dataType: "json",
                data: formValues
            });
            console.info(registrationResponse);

            if (registrationResponse.status !== 'success')
                throw registrationResponse;
            formValues = {
                username: $username.val(),
                lng: i18n.language
            };
            if (registrationResponse.synchronous === 'true') {
                self.submitConfirmMail(formValues);
            } else {
                //TODO: implement with generators
                const isTenantSchemaCreationCompleted = async function () {
                    try {
                        const {schema_creation_status} = await $.ajaxDefaultQ({
                            type: "POST",
                            url: url + "/tenantSchemaCreationCompleted",
                            dataType: "json",
                            data: formValues,
                        });
                        if (schema_creation_status === 'completed') {
                            self.submitConfirmMail(formValues);
                        } else {
                            constraints.disabledThirdPartyActions = true;
                            setTimeout(isTenantSchemaCreationCompleted, 10000);
                        }
                    } catch (e) {
                        console.error(e);
                        setTimeout(isTenantSchemaCreationCompleted, 5000);
                    }
                };
                await isTenantSchemaCreationCompleted();
            }
        } catch (e) {
            console.error(e);
            const msg = {
                'fail': "register.registrationservererror",
                'not_allowed': "register.registrationnotallowed",
                'missing_username_prefix': "register.missingUsernamePrefix",
                'invalid_email': 'register.invalidemail',
                'email_exists': 'register.emailexists',
                'email_exists_locked': 'register.emailexistslocked',
                'username_exists': 'register.usernameexists',
                'username_exists_locked': 'register.usernameexistslocked'
            };
            $registrationMessageContainer.hide();
            const errorMsg = Optional.ofNullable(e.message)
                .orElse(Optional.ofNullable(e.status).flatMap(s => Optional.ofNullable(msg[s])).orElse(""));
            this.alertAndRedirect(errorMsg);
        }
    },
    async alertAndRedirect(msg) {
        $("#spinner").hide();
        await dhtmlx.alert(i18n.t(msg));
        this.trigger("navigation", "");
    },
    async submitConfirmMail(formValues) {
        var self = this;
        var url = '/CampaignCloud/Registration';
        try {
            const registrationData = await $.ajaxDefaultQ({
                type: "POST",
                url: url + "/ConfirmMail",
                dataType: "json",
                data: formValues
            });

            if (registrationData.status === 'success') {
                $("#spinner").hide();
                $("#registration_message_container").hide();
                await dhtmlx.alert(i18n.t("register.checkmail"));
                $("body").removeClass("loading");
                this.trigger("navigation", "");
            } else if (registrationData.status === 'no_need_for_confirmation') {
                $("#spinner").hide();
                $("#registration_message_container").hide();
                await dhtmlx.alert(i18n.t("successfulRegistration"));
                $("body").removeClass("loading");
                let url = '/CampaignCloud/login';
                console.info('Logging in...');
                let formValues = {
                    username: $('#username').val(),
                    password: $('#password').val()
                };
                try {
                    self.getLoginAjax(url, formValues);
                } catch (err) {
                    if (err.status === 403) {
                        let deferred;
                        try {
                            deferred = $.ajaxDefaultQ({
                                url: '/CampaignCloud/RememberMeController/ping',
                                type: 'GET',
                                dataType: "json"
                            });
                            const ping = await deferred;
                            if (ping.status === 'success') {
                                console.info(ping);
                                var storedRef = sessionStorage.getItem("referrer");
                                window.open(storedRef ? storedRef : 'Dashboard.htm', '_self');
                            }
                        } catch (err) {
                            window.csrf = deferred.getResponseHeader('X-CSRF-TOKEN');
                            self.getLoginAjax(url, formValues);
                        }
                    }
                }
            } else {
                this.alertAndRedirect("register.erroronserver");
            }
        } catch (e) {
            console.error(e);
            this.alertAndRedirect("register.internalerror");
        }
    },
    googleAuth: function () {
        this.commonOAuthCallback(0);
    },
    async commonOAuthCallback(provider) {
        if (!constraints.disabledThirdPartyActions) {
            var url = '/CampaignCloud/oauthClient/startAuthentication';
            var formValues = {
                provider: provider,
                state: 'registration'
            };
            console.info(formValues);
            try {
                const {status, LocationUri} = await $.ajaxDefaultQ({
                    url: url,
                    type: 'POST',
                    dataType: "json",
                    data: formValues
                });
                if (status === 'success') {
                    console.info(LocationUri);
                    window.open(LocationUri, '_self');
                } else if (status === 'fail') {
                    dhtmlx.alert(i18n.t("login.registrationerror"));
                }
            } catch (response) {
                console.info(response);
            }
        }
    },
    yahooAuth: function () {
        this.commonOAuthCallback(1);
    },
    microsoftAuth: function () {
        this.commonOAuthCallback(2);
    },
    checkIfAllEmpty: function () {
        if (!$('#email').val() && !$('#password').val() && !$('#username').val()) {
            $("#btn-warning").hide();
        }
    },
    shouldSubmit: function () {
        var username = $('#username').val();
        var reUsername = new RegExp(/^([A-Za-z0-9.]{6,30})$/);

        var email = $('#email').val();
        var reEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;

        if (email.length === 0 || !reEmail.test(email)) {
            this.checkEmail();
            return false;
        } else if (username.length === 0 || !reUsername.test(username)) {
            this.checkUserName();
            return false;
        } else if ($("#password").val().length < 6) {
            $('#password').trigger("keyup");
            return false;
        }
        return true;
    }
});

export {RegistrationView as default};